module.exports = {
  SELL_WITH_DIBBS: 'https://pages.dibbs.io/sellwithdibbs',
};
